import { trpc } from '@/shared/api/trpc';
import { LATEST_ORG_TICKETS_LIMIT } from '../model/support-constants';

// Cross-reporter recent tickets (drawer "Recent" tab) — minimal projection,
// never another reporter's description/attachments/resolution. `enabled`
// lets the drawer defer the fetch until it is opened / this tab is active.
export const useRecentTickets = (enabled = true) =>
  trpc.support.recentList.useQuery(
    { limit: LATEST_ORG_TICKETS_LIMIT },
    { enabled }
  );
